import {Component, DestroyRef, effect, inject, Input, OnInit} from '@angular/core';
import {BreakpointObserver} from '@angular/cdk/layout';
import {NavigationEnd, Router} from '@angular/router';
import {CommunicationService, CompanyService, getSafeImageUrl, ProjectService, ScreenService} from '@app/core';
import {User} from '../../models/partner/user';
import {AuthService} from '../../../core/services/auth.service';
import {takeUntilDestroyed, toObservable} from '@angular/core/rxjs-interop';
import {Company} from '../../models/companies';
import {OidcSecurityService} from 'angular-auth-oidc-client';

@Component({
  selector: 'app-sidebar',
  standalone: false,

  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.less'
})
export class SidebarComponent implements OnInit {

  @Input() isDetailRoute: boolean = false;

  public readonly oidcSecurityService = inject(OidcSecurityService);

  getSafeImageUrl =getSafeImageUrl;

  isCollapsed = true;
  isMobile$: any = null;

  currentRouteLabel: string = '';

  inboxNotification = 0
  private destroyRef = inject(DestroyRef);

  loggedUser: User | undefined;
  loggedUserInitials: string = '';

  selectedCompany: Company | undefined;
  selectedCompanyInitials: string = ''

  menuItems = [
    // {label: 'Inicio', icon: 'home', route: 'home'},
    {label: 'Notificaciones', icon: 'notifications', route: 'inbox', color: '#EA3E83'},
    {label: 'Proyectos', icon: 'folder_copy', route: 'project', color: '#8E4EC6'}, //#F9F1FE
    {label: 'Administración', icon: 'monitoring', route: 'administration', color: '#0072F5'},
    // {label: 'Documentos', icon: 'description', route: 'documents'},
    // {label: 'Catálogos', icon: 'auto_stories', route: 'catalog'},
    {label: 'Usuarios', icon: null, route: 'user', color: '#12A594'},
    // {label: 'Configuración', icon: null, route: 'configuration'},
  ];

  maestrosSubmenuItems = [
    { label: 'Contactos', icon: 'home', route: 'partner' },
    { label: 'Conductores', icon: 'home', route: 'driver' },
    { label: 'Usuarios', icon: 'home', route: 'user' },
    { label: 'Compañias', icon: 'home', route: 'company' },
    { label: 'Estados de contacto', icon: 'home', route: 'state' },
    { label: 'Tipos de contacto', icon: 'home', route: 'partner-type' },

    { label: 'Localizaciones', icon: 'pin_drop', route: 'location' },
    { label: 'Países', icon: 'south_america', route: 'country' },
    { label: 'Monedas', icon: 'home', route: 'currency' },
    // { label: 'Tipos de Cambio', icon: 'home', route: 'currency-exchange' },
    { label: 'Tipos de Localización', icon: 'pin_drop', route: 'location-type' },

    { label: 'Navieras', icon: 'box', route: 'shipping' },
    { label: 'Motonaves', icon: 'box', route: 'motonave' },
    { label: 'Mercancías', icon: 'box', route: 'good' },
    { label: 'Equipos', icon: 'box', route: 'equipment' },
    { label: 'Tipos de Transportes', icon: 'home', route: 'transport-type' },
    { label: 'Tipos de Paquete', icon: 'box', route: 'package-type' },

    { label: 'Flujos', icon: 'flow', route: 'flow' },
    { label: 'Tipos de Servicio', icon: 'home', route: 'service-type' },
    { label: 'Tipos de Servicios Analíticos', icon: 'home', route: 'type-analytic-service' },
    { label: 'Tipos de Documento', icon: 'description', route: 'document-type' },


    // { label: 'Tipos de Tarifa', icon: 'home', route: 'fee-type' },
    // { label: 'Tarifas', icon: 'home', route: 'fee' },
  ];
  groupedMaestrosSubmenuItems:any[][] = [
    this.maestrosSubmenuItems.slice(0,6),
    this.maestrosSubmenuItems.slice(6,10),
    this.maestrosSubmenuItems.slice(10,16),
    this.maestrosSubmenuItems.slice(16)
  ]

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private mobileService: ScreenService,
    private authService: AuthService,
    private projectService: ProjectService,
    private companyService: CompanyService,
    private communicationService:CommunicationService,
  ) {
    authService.loggedUser
      .pipe(takeUntilDestroyed())
      .subscribe({
        next: (value) => {
          if (value) {
            this.loggedUser = value;
            this.loggedUserInitials = this.loggedUser!.partner!.name.slice(0, 1) + this.loggedUser!.partner!.surName?.slice(0, 1);


            const storageCompanyId = localStorage.getItem('companyId');
            const storageCompany = this.loggedUser!.companies.find(c => c.id.toString() === storageCompanyId)

            this.selectCompany(storageCompany || this.loggedUser!.companies[0]);
            this.updateInboxNotifications();
          }
        },
        error: (e) => console.error(e),
      })
    // toObservable(this.communicationService.refreshNeeded).pipe(takeUntilDestroyed())
    //   .subscribe(()=>this.updateInboxNotifications())
    effect(() => {
      const refreshCount=this.communicationService.refreshNeeded();
      this.updateInboxNotifications();
    });
  }

  ngOnInit(): void {
    this.isMobile$ = this.mobileService.isMobile$;

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const currentPath = event.urlAfterRedirects.split('/').pop(); // Obtiene la última parte de la URL
        const menuItems = [...this.menuItems, ...this.maestrosSubmenuItems, {label: 'Búsqueda', icon: '', route: 'search'}];
        const foundItem = menuItems.find(item => item.route === currentPath);
        this.currentRouteLabel = foundItem ? foundItem.label : 'Desconocido';
      }
    });
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  canViewMaestrosMenu(): boolean {
    return !!(
      this.loggedUser?.viewMaestros ||
      this.loggedUser?.viewEquipmentMaestro ||
      this.loggedUser?.viewDriverMaestro
    );
  }

  canViewMaestroItem(item: { route: string }): boolean {
    if (!this.loggedUser) return false;
    if (this.loggedUser.viewMaestros) return true;

    if (item.route === 'driver') return !!this.loggedUser.viewDriverMaestro;
    if (item.route === 'equipment') return !!this.loggedUser.viewEquipmentMaestro;

    return false;
  }

  selectCompany(company: Company): void {
    localStorage.setItem('companyId', company.id.toString());
    this.companyService.selectedCompanyId = company.id;
    this.selectedCompany = company;
    this.selectedCompanyInitials = this.selectedCompany.name
      .split(/\s+/) // Dividir por cualquier cantidad de espacios
      .filter(word => word.length > 0) // Filtrar palabras vacías
      .map(word => word[0].toUpperCase()) // Tomar primera letra y capitalizar
      .join(''); // Unir las iniciales
  }

  private updateInboxNotifications(): void {
    if (!this.loggedUser) return;

    this.communicationService.getPendingNotification(this.loggedUser.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: value => {
          value.data.rows ? this.inboxNotification = value.data.rows.filter(not => !not.isRead).length : this.inboxNotification = 0;
        },
        error: err => console.error('Error loading notifications', err)
      });
  }

  logout() {
    this.oidcSecurityService
      .logoff()
      .subscribe();
  }

}
